import React from 'react';

const Footer = () => {
  return (
    <footer className='mt-12 text-center border-t border-slate-200 py-6'>
      <a
        href='https://www.claimup.io'
        className='text-sm text-slate-500 hover:text-slate-700 transition-colors duration-150'
      >
        © {new Date().getFullYear()} ClaimUp · Todos los derechos reservados
      </a>
    </footer>
  );
};

export default Footer;
